import { Observable } from 'rxjs';

export interface ObligationForm {
  or_number: string,
  or_date: string,
  or_fund_code: string,
  or_fund_code_name: string,
  or_particulars: string,
  or_supervisor_position: string | number,
  or_supervisor_department: string | number,
  or_supervisor_emp_code: string,
  or_supervisor_fullname: string,
  or_supervisor_position_name: string,
  or_campus: string | number,
  fund_source: Array<FundSource>,
  payee: Array<Payee>
}

export interface FundSource {
  ofs_fund_code: string,
  ofs_fund_sysref_code: string,
  ofs_fund_name: string,
  account: Array<Account>
}

export interface Account {
  aa_id: string,
  oa_uacs_code: string,
  oa_acct_name: string,
  oa_sysref_code: string,
  oa_sysref_name: string,
  function: Array<Function>
}

export interface Function {
  caa: any,
  caa_id: string | number | null,
  of_fund_code: string,
  of_fund_sysref_code: string,
  of_fund_name: string,
  of_amount: string | number,
  of_payment: string | number,
  status: Array<Status>
}

export interface Status {
  os_uacs_code: string,
  os_sysref_code: string,
  os_obligation: string | number,
  os_payable: string | number,
  os_savings: string | number,
  os_remarks: string,
  os_date: string,
  details: Array<StatusPayablePayments>
}

export interface StatusPayablePayments {
  payee_id: number,
  payee_name: string,
  ospp_payable: string | number,
  ospp_payment: string | number,
  ospp_savings: string | number,
  ospp_remarks: string,
  ospp_date: string
}


export interface Payee {
  op_name: string,
  op_office: string,
  op_address: string,
  op_tin: string
}

export interface Summary {
  class: string,
  fund: string,
  campus: string,
  year: string
}

export interface ObligationListParams {
  year: string,
  campus: string | number,
  date_from: string,
  date_to: string
}

export interface UnObligatedAllotmentParams {
  id: string | number,
  dt: string,
}

export interface ApiResponse {
  code: number,
  message: any
}

export abstract class ObligationData {
  abstract save(form: ObligationForm): Observable<ApiResponse>;
  abstract nextSeries(params: any): Observable<ApiResponse>;
  abstract get(year: string | number, campus: string | number, page: string | number, page_size: string | number): Observable<ApiResponse>;
  abstract getSummary(form: Summary): Observable<ApiResponse>;
  abstract delete(id: number): Observable<ApiResponse>;
  abstract update(params: any): Observable<ApiResponse>;
  abstract search(params: any): Observable<ApiResponse>;
  abstract updateRemarks(params: any): Observable<ApiResponse>;
  abstract restore(params: any): Observable<ApiResponse>;
  abstract getTotalItemAmount(id: number): Observable<ApiResponse>;
  abstract deleteStatus(id: number): Observable<ApiResponse>;
  abstract getListSummary(params: ObligationListParams): Observable<ApiResponse>;
  abstract getUnObligatedAllotment(params: UnObligatedAllotmentParams): Observable<ApiResponse>;
}
